// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608260355/js/" + chunkId + "." + {"44":"2bfc436c","225":"fd285712","481":"33676c11","486":"84935ea3","770":"2f9e5f8d"}[chunkId] + ".0.2718212796853249.chunk.js";
};